class PaymentMethodDTO {

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

}

export default PaymentMethodDTO